import { ReactNode } from "react";

type Props = {
  label?: ReactNode;
  hint?: ReactNode;
  children: ReactNode;
};

export function Field({ label, hint, children }: Props) {
  return (
    <div style={{ marginBottom: 14 }}>
      {label && <label className="tcg-label">{label}</label>}
      {children}
      {hint && <div className="tcg-helper">{hint}</div>}
    </div>
  );
}
